import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import { TRANSCRIPTION_STATES } from "../../constants";
import TranscribingIndicator from "./TranscribingIndicator";
import TranscribeStopped from "./TranscribeStopped";
import TranscribeRestarting from "./TranscribeRestarting";

/**
 * Unified indicator component that handles all different states of the transcription process
 * This component consolidates the rendering logic for different transcribe states into one place
 */
const TranscribeBoxIndicator = ({
  transcriptionState,
  rtmsRequesterName,
  isRtmsStartedByOther,
  isRestarting
}) => {
  return (
    <>
      {/* LOADING state when transcription is being restarted due to rtms error */}
      {transcriptionState === TRANSCRIPTION_STATES.LOADING && isRestarting && (
        <TranscribeRestarting />
      )}

      {/* REJECTED state - someone else is starting transcription */}
      {transcriptionState === TRANSCRIPTION_STATES.REJECTED && rtmsRequesterName && (
        <>
          <Column height="16px"/>
          <Row width="100%" spacing="none" spacingInset="none">
            <Column width="72px"/>
            <Column spacing="none">
              <Row alignmentHorizontal="start">
                <Text fontFamily="amazonEmber" type="h50" color="secondary">
                  {rtmsRequesterName}
                </Text>
              </Row>
              <Row alignmentHorizontal="start">
                <Text fontFamily="amazonEmber" type="b200" color="secondary">
                  is starting transcription
                </Text>
              </Row>
            </Column>
          </Row>
        </>
      )}

      {/* STOPPED state - transcription has ended */}
      {transcriptionState === TRANSCRIPTION_STATES.STOPPED && (
        <TranscribeStopped />
      )}

      {/* TRANSCRIBING state - actively transcribing */}
      {transcriptionState === TRANSCRIPTION_STATES.TRANSCRIBING && (
        <TranscribingIndicator 
          rtmsRequesterName={rtmsRequesterName} 
          isRtmsStartedByOther={isRtmsStartedByOther}
        />
      )}
    </>
  );
};

export default TranscribeBoxIndicator;
